import React, { ReactNode } from 'react';
import Typography, { TypographyProps } from '@mui/material/Typography';

interface SectionTitleProps extends TypographyProps {
  children: ReactNode;
  size?: 'sm' | 'md' | 'lg';
  sx?: TypographyProps['sx'];
}

const sizeMap: Record<'sm' | 'md' | 'lg', TypographyProps['variant']> = {
  sm: 'h3',
  md: 'h2',
  lg: 'h1',
};

export default function SectionTitle({
  children,
  size = 'md',
  sx,
  ...typographyProps
}: SectionTitleProps) {
  return (
    <Typography
      variant={sizeMap[size]}
      margin={0}
      padding={0}
      gutterBottom
      sx={sx}
      {...typographyProps}
    >
      {children}
    </Typography>
  );
}
